
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/confirmation",
      function () {
        return require("private-next-pages/create/confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/confirmation"])
      });
    }
  